var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"height":"70vh"}},[_c('login-form'),_c('support-button')],1)}
var staticRenderFns = []

export { render, staticRenderFns }